import React, { Fragment, useCallback, useEffect, useState } from "react";
import classNames from "classnames/bind";
import { Switch, Button, Chip, Toast } from "../../../../components";
import styles from "../Camera.module.css";
import SettingAI from "./SettingAI";
import { lReSo, streamMode, source, protocol } from "./source";
import { recordApi } from "../../../../services/api/RecordApi";
import { aiConfigService } from "../../../../services/api/aiConfigService";
import { camVideoQuality } from "../../../../services/api/camVideoquality";
import { array_move, listAiTranslate } from "../../../../utils";
import { NotificationSettingSpace } from "../../../Notifications";
import { useTranslation } from "react-i18next";
import axiosClient from "../../../../services/axiosClient";
import { Select } from "antd";

const { Option } = Select;
const cx = classNames.bind(styles);
const Setting = ({
  camera,
  type,
  // show,
  onChange,
  // onRecord,
  onClose,
  changeConfigRecord,
  listServiceAI,
  position,
  updateRecord,
  // setDefault,
  isLoading,
  setType,
}) => {
  const [showReload, setShowReload] = useState(false)
  const [setting, setSetting] = useState({
    streamMode: "copy",
    recordMode: camera[0]?.STREAM_MODE,
    status: "",
    protocol: "hls",
    sourceConfig: "MAIN",
    timeKeeping: 3,
    configAi: {},
    recordConfig: {
      TIME_KEEPING: 3,
      TIME_KEEPING_DEFAULT: 3,
    },
    recordStatus: false,
    sourceConfigRc: "SUB",
  });
  const [timeKeeping, setTimeKeeping] = useState();
  const [aiConfig, setAiConfig] = useState();
  const [refresh, setRefresh] = useState(false);
  const { t } = useTranslation();
  const handleChangeQuality = (data) => {
    if (type === "2") {
      setShowReload(true)
      setSetting((prev) => ({ ...prev, sourceConfig: data }));
    } else {
      // if (!setting.recordStatus) {
      setShowReload(true)
      setSetting((prev) => ({ ...prev, sourceConfigRc: data }));
      // } else {
      //   Toast.open(
      //     t("setting.Please_turn_off_the_camera_to_edit_information"),
      //     "danger"
      //   );
      // }
    }
  };
  const handleOnChange = (data) => {
    if (type !== "2") {
      if (camera[0].STATUS === "On") {
        setShowReload(true)
        setSetting((prev) => ({
          ...prev,
          recordStatus: data,
        }));
      } else {
        Toast.open(t("setting.Please_enable_live_streaming"), "danger");
      }
    } else {
      setSetting((prev) => ({ ...prev, status: data }));
      setShowReload(true)

    }
  };
  const getRecordQuality = async (codeCam) => {
    try {
      let params = {
        camera_code: codeCam,
      };
      const recordRate = await recordApi.getRecordQualityConfig(params);

      // console.log(recordRate);

      if (recordRate.length !== 0) {
        if (recordRate.status === 1) {
          setSetting((prev) => ({
            ...prev,
            recordStatus: true,
            sourceConfigRc: recordRate.source_recommend,
            recordMode: recordRate.codec,
          }));
        } else {
          setSetting((prev) => ({
            ...prev,
            recordStatus: false,
            sourceConfigRc: recordRate.source_recommend,
            recordMode: recordRate.codec,
          }));
        }
      }
    } catch (error) {
      console.error("Can't get record rate");
    }
  };
  const getCamQuality = async (codeCam) => {
    try {
      let params = {
        camera_code: codeCam,
      };
      const quality = await camVideoQuality.getCamVideoQuality(params);
      setSetting((prev) => ({
        ...prev,
        // recordStatus: true,
        sourceConfig: quality.source_recommend ? quality.source_recommend : "SUB",
        streamMode: quality.codec ? quality.codec : "copy",
        protocol: quality.stream_protocol ? quality.stream_protocol : "hls",
      }));
    } catch (e) {
      console.log(e);
    }
  };
  const handleUpdate = async () => {
    if (type === "3") {
      await updateRecord(
        camera[0]?.CODE,
        setting.recordConfig?.TIME_KEEPING,
        setting.recordConfig?.TIME_KEEPING_DEFAULT,
        setting.recordStatus,
        timeKeeping,
        camera[0].STATUS,
        aiConfig?.TIME_KEEPING,
        setting.sourceConfigRc,
        setting.recordMode
      );
      if (setting.recordStatus) {
        await getRecordQuality(camera[0]?.CODE);
      }
    } else {
      await onChange(setting, refresh, setRefresh);

      if (setting.status) {
        await getRecordQuality(camera[0]?.CODE);
      }
    }
  };

  useEffect(() => {
    const codeCamera = camera[0]?.CODE;
    if (camera) {
      setSetting((prev) => ({
        ...prev,
        status: camera[0]?.STATUS === "On" ? true : false,
        // sourceConfig: camera[0]?.SOURCE_RECOMMEND || "SUB",
        // streamMode: camera[0]?.STREAM_MODE,
      }));
      if (camera[0]?.STATUS_ACTIVE !== 3) {
        getCamQuality(codeCamera);
        getRecordQuality(codeCamera);
      } else {
      }
    }
  }, [type, camera, refresh]);

  useEffect(() => {
    const codeCamera = camera[0]?.CODE;
    if (codeCamera && !isLoading) {
      const getListConfigRecord = async () => {
        try {
          // await getListCamVideoQuality(codeCamera);
          const res = await recordApi.getRecordConfig(codeCamera);
          const resAI = await aiConfigService.getDefaultConfig(codeCamera);
          setTimeKeeping(res.TIME_KEEPING);
          setSetting((prev) => ({
            ...prev,
            configAi: resAI,
            recordConfig: res,
            timeKeeping: res.TIME_KEEPING,
          }));
          setAiConfig(resAI);
        } catch (error) {
          Toast.open(t("setting.Get_configuration_failed"), "danger");
        }
      };
      getListConfigRecord();
    }
  }, [camera, changeConfigRecord, isLoading, refresh]);
  const handleChangeTimeKepping = (e) => {
    if (
      setting.recordConfig &&
      Number(e.target.value) <= Number(setting.recordConfig?.TIME_KEEPING_DEFAULT)
    ) {
      setShowReload(true)
      setSetting((prev) => ({
        ...prev,
        recordConfig: { ...prev.recordConfig, TIME_KEEPING: e.target.value },
      }));
    } else {
      Toast.open(
        t(
          "setting.Number_of_days_retained_is_greater_than_default_number_of_days"
        ),
        "danger"
      );
    }
  };

  const handleClickDisable = () => {
    if (camera[0].STATUS === "Off" && type === "3") {
      setShowReload(true)
      Toast.open(t("setting.Please_enable_live_streaming"), "danger");
    }
  };

  const onChangeStreamMode = (data) => {
    if (type === "2") {
      setShowReload(true)
      setSetting((prev) => ({ ...prev, streamMode: data }));
    } else {
      setSetting((prev) => ({ ...prev, recordMode: data }));
    }
  };
  const onChangeProtocol = (data) => {
    setShowReload(true)
    setSetting((prev) => ({ ...prev, protocol: data }));
  };
  const handleCancel = () => {
    setRefresh(!refresh);
  };
  return (
    <>
      {type === "4" ? (
        // module cài đặt thông báo riêng _ được lấy từ bên màn quản trị thông báo
        <div className={cx("content-setting")}>
          <NotificationSettingSpace
            cameraInfo={{ code: camera[0].CODE, name: camera[0].CODE }}
          />
        </div>
      ) : (
        <div style={{ padding: "0 16px" }} className={cx("content-setting")}>
          <div className={cx("data")}>
            {(type === "2" || type === "3") && (
              <div className={cx("item-setting")}>
                <span className={cx("name")}>
                  {type === "1" || type === "2"
                    ? t("smartReport.statusCam")
                    : type === "3"
                      ? t("settingCam.Record")
                      : t("stream.status")}
                </span>
                <span
                  style={{ position: "relative", right: 0, marginTop: 0 }}
                  className={cx("info")}
                  onClick={handleClickDisable}
                >
                  <Switch
                    value={type === "2" ? setting.status : setting.recordStatus}
                    type="small"
                    onChange={handleOnChange}
                    disable={type !== "2" && camera[0].STATUS === "Off"}
                  />
                </span>
              </div>
            )}
            {localStorage.getItem("role") === "A" &&
              (type === "2" || type === "3") && (
                <div className={cx("item-setting")}>
                  <div className={cx("name")}>
                    {t("settingCam.Stream_mode")}
                  </div>
                  <div
                    style={{ position: "relative", right: 0 }}
                    className={cx("info")}
                  >
                    <Select
                      size="large"
                      value={
                        type === "2" ? setting.streamMode : setting.recordMode
                      }
                      // disabled={
                      //   type === "2"
                      //     ? !(camera[0]?.STATUS === "Off")
                      //     : setting.recordStatus
                      // }
                      className={cx("select-antd")}
                      style={{
                        width: 200,
                        borderRadius: "4px",
                        fontSize: "14px",
                      }}
                      onChange={(data) => onChangeStreamMode(data)}
                      dropdownStyle={{
                        borderRadius: "4px",
                      }}
                      disabled={!(type === "2" ? setting.status : setting.recordStatus)}
                    // onChange={handleChange}
                    >
                      {streamMode.map((item, index) => {
                        return (
                          <Option value={item.value} key={index}>
                            {item.label}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                </div>
              )}
            {localStorage.getItem("role") === "A" && type === "2" && (
              <div className={cx("item-setting")}>
                <div className={cx("name")}>{t("settingCam.Stream_protocol")}</div>
                <div
                  style={{ position: "relative", right: 0 }}
                  className={cx("info")}
                >
                  <Select
                    size="large"
                    value={setting.protocol}
                    // disabled={
                    //   type === "2"
                    //     ? !(camera[0]?.STATUS === "Off")
                    //     : setting.recordStatus
                    // }
                    className={cx("select-antd")}
                    style={{
                      width: 200,
                      borderRadius: "4px",
                      fontSize: "14px",
                    }}
                    disabled={!(type === "2" ? setting.status : setting.recordStatus)}
                    onChange={(data) => onChangeProtocol(data)}
                    dropdownStyle={{
                      borderRadius: "4px",
                    }}
                  // onChange={handleChange}
                  >
                    {protocol.map((item, index) => {
                      return (
                        <Option value={item.value} key={index}>
                          {item.label}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              </div>
            )}
            {localStorage.getItem("role") === "A" &&
              (type === "1" || type === "2" || type === "3") && (
                <>
                  <div className={cx("item-setting")}>
                    <div className={cx("name")}>
                      {t("smartReport.resolution")}
                    </div>
                    <div
                      style={{ position: "relative", right: 0 }}
                      className={cx("info")}
                    >
                      <Select
                        size="large"
                        value={
                          type === "2"
                            ? setting.sourceConfig
                            : setting.sourceConfigRc
                        }
                        // disabled={
                        //   type === "2"
                        //     ? !(camera[0]?.STATUS === "Off")
                        //     : setting.recordStatus
                        // }
                        style={{
                          width: 200,
                          borderRadius: 4,
                          fontSize: "14px", // Áp dụng cho text trong Select
                        }}
                        onChange={(data) => handleChangeQuality(data, "np")}
                        disabled={!(type === "2" ? setting.status : setting.recordStatus)}
                      >
                        {source.length > 0 ? (
                          source?.map((item, index) => {
                            return (
                              <Option key={index} value={item.value}>
                                {item.label}
                              </Option>
                            );
                          })
                        ) : (
                          <span></span>
                        )}
                      </Select>
                    </div>
                  </div>
                </>
              )}
            {/* {localStorage.getItem("role") === "A" && type === "2" && (
              <div className={cx("item-setting")}>
                <div className={cx("name")}>
                  {t("settingCam.Desktop_resolution")}
                </div>
                <div
                  style={{
                    position: "relative",
                    right: 0,
                    fontSize: 16,
                    marginTop: 0,
                  }}
                  className={cx("info")}
                >
                  {camera[0]?.SUB_SOURCE}
                </div>
              </div>
            )} */}

            {type === "3" && (
              <>
                <div className={cx("item-setting")}>
                  <span className={cx("name")}>
                    {t("settingCam.Recorded_storage_time_Days")}
                  </span>
                  <input
                    onChange={(e) => handleChangeTimeKepping(e)}
                    max={14}
                    min={1}
                    className={cx("date")}
                    type="number"
                    value={setting.recordConfig?.TIME_KEEPING}
                    disabled={setting.recordStatus}
                  />
                </div>
                <div className={cx("item-setting")}>
                  <span style={{ flex: 1 }} className={cx("name")}>
                    {t("settingCam.Time_frame_allowed")}
                  </span>
                  <span
                    style={{
                      flex: 2,
                      display: "flex",
                      gap: 6,
                      flexWrap: "wrap",
                      flexDirection: "row-reverse",
                      marginTop: 0,
                    }}
                    className={cx("info")}
                  >
                    <span className={cx("list-time")}>
                      <Chip title={`00:00-24:00`} onClose={() => 0} />
                    </span>
                  </span>
                </div>
              </>
            )}
            {listServiceAI.length > 0 &&
              listServiceAI.map((service) => {
                if (type === service.key) {
                  return (
                    <SettingAI
                      key={service.key}
                      cameraCode={camera[0].CODE}
                      onClose={onClose}
                      codeService={service.key}
                      nameService={
                        listAiTranslate.find(
                          (ai) => ai.name_tr === service?.name
                        )?.ai_name || service?.name
                      }
                      position={position}
                      aiConfig={aiConfig}
                      setAiConfig={setAiConfig}
                      setType={setType}
                    />
                  );
                } else {
                  return "";
                }
              })}
          </div>
          {(type === "2" || type === "3") && (
            <div className={cx("actions-setting")}>
              {
                showReload && <Button
                  className={cx("btn-cancle")}
                  title={t("cameraControl.Cancel")}
                  onClick={handleCancel}
                />
              }
              <Button
                onClick={handleUpdate}
                className={cx("btn-save")}
                title={t("settingCam.Save_settings")}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Setting;
